import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NpsHelpModalComponent } from "../nps-help-modal/nps-help-modal.component";
import { PerfHelpModalComponent } from "../perf-help-modal/perf-help-modal.component";

@Component({
  selector: 'app-perf-help',
  templateUrl: './perf-help.component.pug',
  styleUrls: ['./perf-help.component.scss'],
  standalone: false
})
export class PerfHelpComponent implements OnInit {
  @Input() request;
  bsModalRef!: BsModalRef;

  constructor(private modalService: BsModalService,) {
  }

  ngOnInit(): void {
  }

  showHelp(): void {
    let initialState = { 'request': this.request };
    if (this.request == 'exit') {
      this.bsModalRef = this.modalService.show(PerfHelpModalComponent, {
        class: 'modal-dialog-centered modal-lg' , initialState
      });
    }
    else if (this.request == 'pulse') {
      this.bsModalRef = this.modalService.show(PerfHelpModalComponent, {
        class: 'modal-centered max-width-504 max-height-468', initialState
      });
    }
  }
}
